/* GermanyKG Favoriten (Herz) – global auf allen Seiten.
   Gäste: Browser-Speicher + anonyme ID (Auswertung). Kunden: Konto (Server = Wahrheit).
   Beim Anmelden werden Browser-Favoriten ins Konto übernommen (mergeAfterLogin). */
(function () {
  'use strict';

  var API = '/apps/konto/api/favorites';
  var K_FAV = 'gkg_favs', K_ANON = 'gkg_anon', K_SESSION = 'gkg_session', K_PENDING = 'gkg_merge_pending';
  var MAX = 50;
  var GUEST_MAX = 5; // ohne Login: nur 5 Favoriten (Anreiz zur Registrierung)
  var LOGIN_URL = '/pages/konto-login';
  var T = {
    limit: 'Можно сохранить не более 50 товаров.',
    guestLimit: 'Без входа можно сохранить не более 5 товаров — и список может потеряться. Войдите, чтобы сохранить избранное без ограничений.',
    guestNote: 'Вы не вошли: избранное хранится только в этом браузере и может потеряться. Вход сохранит ваш список.',
    login: 'Войти',
    add: 'В избранное', remove: 'Убрать из избранного', sizeSaved: 'Размер сохранён: ',
    empty: 'Список избранного пока пуст.', toCatalog: 'Перейти в каталог',
    filterAll: 'Все', filterAvail: 'В наличии', noneAvail: 'Из избранного сейчас ничего нет в наличии.',
    sizeLabel: 'Ваш размер:',
    size: 'Размер', chooseSize: 'выбрать размер', out: 'нет в наличии', gone: 'товар недоступен',
    wa: 'Отправить список в WhatsApp',
    waIntro: 'Здравствуйте! Меня интересуют эти товары:', more: '…и ещё'
  };

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lss(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsd(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function hex32() {
    var a = new Uint8Array(16);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(a); else for (var i = 0; i < 16; i++) a[i] = Math.random() * 256 | 0;
    var s = ''; for (var j = 0; j < 16; j++) s += ('0' + a[j].toString(16)).slice(-2); return s;
  }
  function anonId() { var a = ls(K_ANON); if (!a || !/^[a-f0-9]{32}$/.test(a)) { a = hex32(); lss(K_ANON, a); } return a; }
  function rotateAnon() { lsd(K_ANON); } // neue Gast-Kennung beim nächsten Bedarf
  function session() { return ls(K_SESSION) || ''; }
  var gen = 0; // Änderungszähler: eine ältere Server-Antwort darf einen frischeren Klick nicht überschreiben
  function valid(i) { return !!i && typeof i === 'object' && /^\d{1,20}$/.test(String(i.product_id || '')) && /^[^\/?#\s]+$/.test(String(i.handle || '')); }
  function load() { try { var l = JSON.parse(ls(K_FAV) || '[]'); return Array.isArray(l) ? l.filter(valid) : []; } catch (e) { return []; } }
  function store(l) { lss(K_FAV, JSON.stringify(l.filter(valid).map(norm).slice(0, MAX))); hydrate(); }
  function save(l) { gen++; store(l); }
  function headers() {
    var h = { 'Content-Type': 'application/json' };
    var s = session(); if (s) h['Authorization'] = 'Bearer ' + s; else h['X-Anon-Id'] = anonId();
    return h;
  }
  function api(path, body) {
    return fetch(API + path, { method: body ? 'POST' : 'GET', headers: headers(), body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        // abgelaufene/zurückgezogene Sitzung → lokal vergessen (auch die Liste: geteilte Geräte), ab jetzt Gast
        if (r.status === 401 && session()) { lsd(K_SESSION); clearLocal(); }
        return r.json().catch(function () { return {}; });
      })
      .catch(function () { return { ok: false, error: 'network' }; });
  }
  function norm(i) {
    return { product_id: String(i.product_id), handle: String(i.handle || ''),
      variant_id: i.variant_id ? String(i.variant_id) : null, size: i.size || null, title: i.title || null };
  }
  function same(a, pid, vid) { return a.product_id === String(pid) && (a.variant_id || '') === (vid || ''); }
  function entriesOf(pid) { return load().filter(function (i) { return i.product_id === String(pid); }); }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'gkg-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('gkg-toast--show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('gkg-toast--show'); }, 2200);
  }

  // Gäste-Limit erreicht: Hinweis mit Login-Knopf (fördert Registrierung)
  var limitEl;
  function guestLimitPrompt() {
    if (!limitEl) {
      limitEl = document.createElement('div'); limitEl.className = 'gkg-fav-limit';
      var p = document.createElement('p'); p.textContent = T.guestLimit; limitEl.appendChild(p);
      var a = document.createElement('a'); a.href = LOGIN_URL; a.textContent = T.login; limitEl.appendChild(a);
      document.body.appendChild(limitEl);
    }
    limitEl.classList.add('gkg-fav-limit--show');
    clearTimeout(limitEl._t); limitEl._t = setTimeout(function () { limitEl.classList.remove('gkg-fav-limit--show'); }, 7000);
  }

  function add(item) {
    var it = norm(item); var l = load();
    if (l.some(function (i) { return same(i, it.product_id, it.variant_id); })) return Promise.resolve({ ok: true });
    if (!session() && l.length >= GUEST_MAX) { guestLimitPrompt(); return Promise.resolve({ ok: false, error: 'guest_limit' }); }
    if (l.length >= MAX) { toast(T.limit); return Promise.resolve({ ok: false, error: 'limit_reached' }); }
    l.unshift(it); save(l);
    /* gkg 28.09.2026: Journey-Event — Favorit ist eine der Ziel-Aktionen des Katalog-Shops */
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'gkg_favorite_add', {
          product_handle: it.handle || null, product_id: it.product_id || null,
          size: it.size || null, transport_type: 'beacon'
        });
      }
    } catch (e) {}
    return api('', { product_id: it.product_id, handle: it.handle, variant_id: it.variant_id, size: it.size,
      title: it.title, source: item.source || 'card' }).then(function (r) {
      if (!r.ok && r.error === 'limit_reached') { save(load().filter(function (i) { return !same(i, it.product_id, it.variant_id); })); toast(T.limit); }
      return r;
    });
  }
  function remove(pid, vid, all) {
    save(load().filter(function (i) { return all ? i.product_id !== String(pid) : !same(i, pid, vid); }));
    return api('/remove', { product_id: String(pid), variant_id: vid || null, all: !!all });
  }
  function syncFromServer() {
    if (!session() || ls(K_PENDING)) return Promise.resolve();
    var g = gen;
    return api('').then(function (r) { if (r.ok && Array.isArray(r.items) && g === gen) store(r.items); });
  }
  // Beim Anmelden: Gästeliste ins Konto. Scheitert es (Netz), bleibt ein Merker und es wird beim nächsten Seitenaufruf wiederholt.
  function mergeAfterLogin() {
    lss(K_PENDING, '1');
    return api('/merge', { anon_id: anonId(), items: load() }).then(function (r) {
      if (r.ok && Array.isArray(r.items)) { lsd(K_PENDING); rotateAnon(); store(r.items); }
      return r;
    });
  }
  // Abmelden / Sitzung ungültig: Liste leeren + neue Gast-Kennung (Gerät kann von anderen genutzt werden)
  function clearLocal() { lss(K_FAV, '[]'); lsd(K_PENDING); rotateAnon(); hydrate(); }

  // ---- Produktseite: Größe nur, wenn der Kunde wirklich gewählt hat ----
  var variantChosen = /[?&]variant=\d+/.test(location.search);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-selects, variant-radios, variant-picker, .product-form__input, [name^="options"]')) variantChosen = true;
  }, true);
  function currentVariant(btn) {
    if (btn.getAttribute('data-default-only') === 'true' || !variantChosen) return null;
    var list = []; try { list = JSON.parse(btn.getAttribute('data-variants') || '[]'); } catch (e) {}
    var cands = [], m = location.search.match(/[?&]variant=(\d+)/);
    if (m) cands.push(m[1]);
    // nur das eigene Produkt (Quick-Add-Fenster/andere Sektionen haben eigene Formulare)
    var scope = (btn.closest && btn.closest('product-info, section, .product')) || document;
    var inp = scope.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (inp && inp.value) cands.push(String(inp.value));
    for (var i = 0; i < cands.length; i++) {
      var v = list.filter(function (x) { return String(x.id) === cands[i]; })[0];
      if (v) { var s = v.size || v.title; return { variant_id: cands[i], size: (s && s !== 'Default Title') ? String(s) : null }; }
    }
    return null; // fremde Variante → keine Größe speichern
  }

  // ---- Herzen + Zähler ----
  function hydrate() {
    var l = load();
    var btns = document.querySelectorAll('[data-gkg-fav]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], pid = b.getAttribute('data-product-id');
      var on = l.some(function (x) { return x.product_id === String(pid); });
      if (b.classList.contains('gkg-fav--on') !== on) b.classList.toggle('gkg-fav--on', on);
      var label = on ? T.remove : T.add;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    }
    var cs = document.querySelectorAll('.gkg-fav-count'), s = String(l.length);
    for (var j = 0; j < cs.length; j++) { if (cs[j].textContent !== s) cs[j].textContent = s; cs[j].hidden = l.length === 0; }
    var links = document.querySelectorAll('.header__icon--fav'); // Header-Herz rot, sobald etwas gemerkt ist
    for (var k = 0; k < links.length; k++) { if (links[k].classList.contains('gkg-fav-link--on') !== (l.length > 0)) links[k].classList.toggle('gkg-fav-link--on', l.length > 0); }
    try { document.dispatchEvent(new CustomEvent('gkg:favorites', { detail: { count: l.length } })); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gkg-fav]') : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var pid = btn.getAttribute('data-product-id'), handle = btn.getAttribute('data-handle'),
        title = btn.getAttribute('data-title'), source = btn.getAttribute('data-source') || 'card';
    // Ein Produkt nur EINMAL, und klebrig: ist es gemerkt, entfernt nur ein bewusster
    // Herz-Klick es wieder. Eine andere Größe wählen ändert den Favoriten NICHT (Herz bleibt rot).
    if (entriesOf(pid).length) { remove(pid, null, true); return; }
    // Neu merken — mit der gewählten Größe, falls auf der Produktseite eine gewählt wurde.
    var cv = source === 'product' ? currentVariant(btn) : null;
    add({ product_id: pid, handle: handle, title: title, source: source, variant_id: cv && cv.variant_id, size: cv && cv.size });
  }, true);

  // Dawn rendert Karten/Produktinfo dynamisch neu → Herzen nachziehen (eigene Elemente ignorieren: keine Rückkopplung)
  var mo; function observe() {
    if (mo || !window.MutationObserver) return;
    var t; mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var tg = recs[i].target;
        if (tg && tg.closest && tg.closest('.gkg-fav-count, .gkg-favs, .gkg-toast, .gkg-fav-limit')) continue;
        clearTimeout(t); t = setTimeout(hydrate, 80); return;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ---- Favoriten-Seite ----
  var productCache = Object.create(null);
  // Promise → Produktdaten | null (404: gelöscht/unsichtbar) | undefined (Netzfehler)
  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? null : undefined); })
      .catch(function () { return undefined; });
    return productCache[handle];
  }
  // Preis im Shop-Format (shop.money_format, z. B. "{{amount_no_decimals_with_comma_separator}} KGS")
  var moneyFormat = '';
  function money(cents) {
    var f = moneyFormat || '{{amount_no_decimals}} сом', n = (cents || 0) / 100;
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
    function grp(sep, dec, decimals) {
      var p = n.toFixed(decimals).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return p.length > 1 ? p[0] + dec + p[1] : p[0];
    }
    var s;
    switch (key) {
      case 'amount_no_decimals': s = grp(',', '.', 0); break;
      case 'amount_with_comma_separator': s = grp('.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': s = grp('.', ',', 0); break;
      case 'amount_with_apostrophe_separator': s = grp("'", '.', 2); break;
      case 'amount_no_decimals_with_space_separator': s = grp(' ', ',', 0); break;
      case 'amount_with_space_separator': s = grp(' ', ',', 2); break;
      case 'amount_with_period_and_space_separator': s = grp(' ', '.', 2); break;
      default: s = grp(',', '.', 2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]*>/g, '').trim();
  }
  function el(tag, attrs, children) {
    var e = document.createElement(tag); attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) { if (k === 'class') e.className = attrs[k]; else if (k === 'text') e.textContent = attrs[k]; else if (k.indexOf('on') === 0) e.addEventListener(k.slice(2), attrs[k]); else if (attrs[k] != null && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]); });
    (children || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function waLink(number, entries) {
    var lines = [T.waIntro];
    var shown = 0;
    for (var i = 0; i < entries.length; i++) {
      var s = (i + 1) + '. ' + entries[i].title + (entries[i].size ? ' — ' + T.size.toLowerCase() + ' ' + entries[i].size : '') + '\n' + entries[i].url;
      if ((lines.join('\n') + '\n' + s).length > 3600) break;
      lines.push(s); shown++;
    }
    if (shown < entries.length) lines.push(T.more + ' ' + (entries.length - shown));
    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n'));
  }
  // Größenspektrum je Abteilung (aus dem Katalog ermittelt, Stand 09/2026); Abteilung = Gender-Merker des Shops
  var GENDER_SIZES = {
    male: ['39', '40', '41', '42', '43', '44', '45', '46', '47', '48'],
    female: ['35', '35.5', '36', '37', '37.5', '38', '38.5', '39', '40', '40.5', '41', '42', '43', '44', '45']
  };
  function renderFavoritesPage(root) {
    var number = (root.getAttribute('data-wa') || '').replace(/\D/g, '');
    var catalogUrl = root.getAttribute('data-catalog-url') || '/collections/all';
    moneyFormat = root.getAttribute('data-money-format') || '';
    var filterOn = false; // Verfügbarkeits-Filter überlebt Neuzeichnen (z. B. nach Entfernen)
    var selectedSizes = []; // gewählte Größen (leer + sizeChosen = „Любой размер")
    var sizeChosen = false; // erst nach Größen-Abfrage wird wirklich gefiltert
    function draw() {
      var items = load();
      root.innerHTML = '';
      var head = el('div', { class: 'gkg-favs__head' }, [
        el('h1', { class: 'gkg-favs__title', text: (root.getAttribute('data-title') || 'Ваши фавориты') + (items.length ? ' (' + items.length + ')' : '') })
      ]);
      var wa = el('a', { class: 'gkg-favs__wa', href: '#', target: '_blank', rel: 'noopener', hidden: true, text: T.wa });
      head.appendChild(wa);
      root.appendChild(head);
      // Gäste-Hinweis: Liste ist nur im Browser gespeichert — Login sichert sie
      if (!session() && items.length) {
        root.appendChild(el('div', { class: 'gkg-favs__guest' }, [
          el('span', { class: 'gkg-favs__guest-text', text: T.guestNote }),
          el('a', { class: 'gkg-favs__guest-btn', href: LOGIN_URL, text: T.login })
        ]));
      }
      if (!items.length) {
        root.appendChild(el('div', { class: 'gkg-favs__empty' }, [el('p', { text: T.empty }), el('a', { class: 'gkg-btn gkg-btn--ghost', href: catalogUrl, text: T.toCatalog })]));
        return;
      }
      // Filter „Все / В наличии" mit Größen-Abfrage: erst Größe(n) wählen (oder „Любой размер"),
      // dann größengenau gegen die Varianten filtern. Verfügbarkeit kommt je Karte asynchron.
      var grid = el('div', { class: 'gkg-favs__grid' });
      var filterNote = el('div', { class: 'gkg-favs__filter-empty', text: T.noneAvail }); filterNote.hidden = true;
      var sizesWrap = el('div', { class: 'gkg-favs__sizes' }); sizesWrap.hidden = true;
      var allSizes = {};
      var btnAll, btnAvail;
      function cardVisible(card) {
        if (!filterOn || !sizeChosen) return true;
        if (selectedSizes.length === 0) return card.getAttribute('data-available') !== '0'; // „Любой размер"
        if (card._noSizes) return card.getAttribute('data-available') !== '0'; // größenlose Artikel (Taschen etc.)
        if (!card._sizes) return true; // Produktdaten noch unterwegs → nicht ausblenden
        for (var i = 0; i < selectedSizes.length; i++) if (card._sizes[selectedSizes[i]]) return true;
        return false;
      }
      function applyFilter() {
        btnAll.classList.toggle('gkg-favs__filter-btn--on', !filterOn);
        btnAvail.classList.toggle('gkg-favs__filter-btn--on', filterOn);
        sizesWrap.hidden = !filterOn;
        var visible = 0;
        for (var i = 0; i < grid.children.length; i++) {
          var show = cardVisible(grid.children[i]);
          grid.children[i].style.display = show ? '' : 'none';
          if (show) visible++;
        }
        filterNote.hidden = !(filterOn && sizeChosen && visible === 0);
      }
      function rebuildSizes() {
        while (sizesWrap.firstChild) sizesWrap.removeChild(sizesWrap.firstChild);
        sizesWrap.appendChild(el('span', { class: 'gkg-favs__sizes-label', text: T.sizeLabel }));
        // Basis = alle Größen der gewählten Abteilung; Größen aus den Favoriten kommen obendrauf
        var g = ''; try { g = localStorage.getItem('gkg_gender') || ''; } catch (e) {}
        var base = GENDER_SIZES[g] || GENDER_SIZES.female.concat(GENDER_SIZES.male);
        var set = {};
        base.forEach(function (s) { set[s] = 1; });
        Object.keys(allSizes).forEach(function (s) { set[s] = 1; });
        var keys = Object.keys(set).sort(function (a, b) { return (parseFloat(a) || 999) - (parseFloat(b) || 999); });
        keys.forEach(function (s) {
          var on = selectedSizes.indexOf(s) >= 0;
          sizesWrap.appendChild(el('button', { class: 'gkg-favs__size-btn' + (on ? ' gkg-favs__size-btn--on' : ''), type: 'button', text: s,
            onclick: function () {
              var i = selectedSizes.indexOf(s);
              if (i >= 0) selectedSizes.splice(i, 1); else selectedSizes.push(s);
              sizeChosen = selectedSizes.length > 0; // alles abgewählt = wieder ungefiltert
              rebuildSizes(); applyFilter();
            } }));
        });
      }
      btnAll = el('button', { class: 'gkg-favs__filter-btn', type: 'button', text: T.filterAll,
        onclick: function () { filterOn = false; applyFilter(); } });
      btnAvail = el('button', { class: 'gkg-favs__filter-btn', type: 'button', text: T.filterAvail,
        onclick: function () { filterOn = true; rebuildSizes(); applyFilter(); } });
      root.appendChild(el('div', { class: 'gkg-favs__filter' }, [btnAll, btnAvail]));
      root.appendChild(sizesWrap);
      root.appendChild(filterNote);
      root.appendChild(grid);
      rebuildSizes(); applyFilter();
      // sofort aus lokalen Daten zeichnen, Shopify-Daten (Bild, Preis, Verfügbarkeit) je Karte nachladen
      var entries = items.map(function (it) {
        return { title: it.title || it.handle, size: it.size, url: location.origin + '/products/' + encodeURIComponent(it.handle) };
      });
      function updateWa() { if (number && entries.length) { wa.href = waLink(number, entries); wa.hidden = false; } }
      updateWa();
      items.forEach(function (it, idx) {
        var url = entries[idx].url;
        var img = el('div', { class: 'gkg-favs__img' });
        var imgLink = el('a', { href: url }, [img]);
        var nameEl = el('a', { class: 'gkg-favs__name', href: url, text: entries[idx].title });
        var priceEl = el('div', { class: 'gkg-favs__price' });
        var sizeEl = el('div', { class: 'gkg-favs__size' }, it.size ? [T.size + ': ' + it.size] : [el('a', { href: url, text: T.chooseSize })]);
        var body = el('div', { class: 'gkg-favs__body' }, [nameEl, priceEl, sizeEl]);
        var card = el('div', { class: 'gkg-favs__item' }, [imgLink, body,
          el('button', { class: 'gkg-favs__remove', type: 'button', 'aria-label': T.remove, text: '×',
            onclick: function () { remove(it.product_id, it.variant_id, false); draw(); } })]);
        grid.appendChild(card);
        fetchProduct(it.handle).then(function (p) {
          if (p === null) { // Produkt nicht mehr im Shop
            body.appendChild(el('span', { class: 'gkg-favs__badge gkg-favs__badge--out', text: T.gone }));
            nameEl.removeAttribute('href'); imgLink.removeAttribute('href'); sizeEl.textContent = it.size ? (T.size + ': ' + it.size) : '';
            card._sizes = {}; card._noSizes = false; // weg = in keiner Größe verfügbar
            card.setAttribute('data-available', '0'); applyFilter();
            return;
          }
          if (!p) return; // Netzfehler → lokale Daten bleiben
          var title = p.title || entries[idx].title;
          nameEl.textContent = title; entries[idx].title = title; updateWa();
          if (p.featured_image) {
            var src = String(p.featured_image).replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1$2');
            var im = el('img', { class: 'gkg-favs__img', src: src, alt: title, loading: 'lazy' }); imgLink.replaceChild(im, img); img = im;
          }
          var v = it.variant_id ? (p.variants || []).filter(function (x) { return String(x.id) === it.variant_id; })[0] : null;
          var available = v ? v.available : p.available;
          var price = v ? v.price : p.price;
          if (price != null) priceEl.textContent = money(price);
          if (!available) body.appendChild(el('span', { class: 'gkg-favs__badge gkg-favs__badge--out', text: T.out }));
          // Größen je Variante einsammeln (Option 1 = „Доступные размеры"; Taschen o. Ä. haben nur „Default Title")
          card._sizes = {}; card._noSizes = false;
          (p.variants || []).forEach(function (x) {
            var s = String(x.option1 || String(x.title || '').split(' / ')[0] || '').trim();
            if (!s || !/^\d+(\.\d+)?$/.test(s)) { card._noSizes = true; return; } // keine echte Größe (Default/Farbe) → größenlos
            allSizes[s] = 1;
            if (x.available) card._sizes[s] = true;
          });
          if (!sizesWrap.hidden) rebuildSizes();
          card.setAttribute('data-available', available ? '1' : '0'); applyFilter();
        });
      });
    }
    draw();
  }

  window.GkgFav = { add: add, remove: remove, load: load, syncFromServer: syncFromServer, mergeAfterLogin: mergeAfterLogin, clearLocal: clearLocal, hydrate: hydrate };

  function init() {
    hydrate(); observe();
    var page = document.querySelector('[data-gkg-favorites]');
    if (page) renderFavoritesPage(page); // sofort aus lokalen Daten
    if (session()) {
      var before = ls(K_FAV);
      (ls(K_PENDING) ? mergeAfterLogin() : Promise.resolve()).then(syncFromServer).then(function () {
        if (page && ls(K_FAV) !== before) renderFavoritesPage(page); // nur neu zeichnen, wenn sich etwas geändert hat
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
